<template>
  <router-view />
</template>

<script>
import store, { name as moduleName } from '@/modules/billingHistory/store';
import storeMixin, { unRegisterMixin } from 'utils/mixins/storeGenerator';
import visitRegistryStore, {
  name as visitRegistryModuleName,
} from '@/modules/visitRegistry/store';

export default {
  name: 'BillingHistoryWrapper',
  mixins: [storeMixin, unRegisterMixin],
  created() {
    if (this.$store.state[moduleName] == undefined) {
      this.$store.registerModule(moduleName, store);
    }
    if (this.$store.state[visitRegistryModuleName] == undefined) {
      this.$store.registerModule(visitRegistryModuleName, visitRegistryStore);
    }
  },
  destroyed() {
    this.$store.commit(`${moduleName}/dispose`);
  },
};
</script>
